import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import {EMPTY, Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SecurityService } from './security.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private securityService: SecurityService, private router: Router, private activatedRoute: ActivatedRoute) {
  }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if ([401].includes(err.status)) {
                 this.securityService.login();
                return throwError(err);
            }

            const error = err.error || err.statusText;

            if(error.invalidFields) {
                error.invalidFieldsData = {};
                for (const field of error.invalidFields) {
                    error.invalidFieldsData[field.fieldName] = field.errors;
                }
            }

            console.error(err);
            return throwError(() => error);
        }))
    }
}
